import React, { useState } from 'react';
import { formatPrice } from '../hooks/contractHelper';
import { useClaimedRewardStats } from '../hooks/useAccount';

export default function TotalRewardModal({ show, setShow }) {
    const handleClose = () => setShow(false);
    const [chainId, setChainId] = useState(5512);
    const rewardState = useClaimedRewardStats(chainId);


    return (
        <div className={`modal fade ${show ? 'show d-block' : ''}`}
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden={!show}
            style={{ display: show ? 'block' : 'none' }}>
            <div class="modal-dialog modal-dialog-centered">
                <div className="modal-content bg-dark">
                    <div className="modal-header">
                        <p className="modal-title fs-5" id="staticBackdropLabel">Total Distributed Reward</p>
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <ul class="nav nav-pills nav-fill">
                            <li class="nav-item">
                                <a onClick={() => setChainId(5512)} class={`nav-link ${chainId === 5512 ? 'active' : ''}`} aria-current="page" href="#">BlockStar Chain</a>
                            </li>
                            <li class="nav-item">
                                <a onClick={() => setChainId(11155111)} class={`nav-link ${chainId === 11155111 ? 'active' : ''}`} aria-current="page" href="#">Ethereum Chain</a>
                            </li>
                            <li class="nav-item">
                                <a onClick={() => setChainId(56)} class={`nav-link ${chainId === 56 ? 'active' : ''}`} aria-current="page" href="#">Bianance Chain</a>
                            </li>

                        </ul>
                        <div className='m-4 text-center'>
                            {rewardState && rewardState.finalData.length > 0 ? (
                                rewardState.finalData.map((items, key) => (
                                    items.balance > 0 &&
                                    <>
                                        <p style={{marginBottom : "8px"}} className='fs-5' key={key}>{formatPrice(items.balance)} {items.symbol}</p>
                                    </>
                                ))) : (
                                <span className='fs-5'>No reward</span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
